import { useUserStore } from '~/store/user'
import { ExemptedPaths } from '~/model/ExemptedPath'

export default async function ({ pinia, redirect, route, $auth }) {
    if (!$auth.loggedIn) {
        return
    }

    if (isPathExempted(route.path)) {
        return
    }
    const userStore = useUserStore(pinia)
    const xeroInfo = await userStore.fetchXeroInfo()
    const userInfo = await userStore.fetchUser()

    if (!xeroInfo.isConnected || !userInfo.hasServiceKeys) {
        return redirect('/')
    }
}

function isPathExempted(path) {
    return Object.values(ExemptedPaths).includes(path)
}
